import { LangCode } from "../models";

export interface CategoryInput {
  id?: number;
  img: string;
  parent_id: number;
  translations: Array<{
    lang_code: LangCode;
    cate_name: string;
    spec: { [key: string]: string };
  }>;
}
export interface CategoryUpdateInput {
  id: number;
  cate_name?: string;
  spec?: { [key: string]: string };
}

export interface CategoryFilterInput {
  page: number;
  limit: number;
  filters: Filters;
}

export interface Filters {
  and: Array<any>;
  or: Array<any>;
}
